import styled, { css, DefaultTheme } from 'styled-components';

type WrapperProps = {
  variant: 'primary' | 'secondary';
};

const wrapperModifiers = (theme: DefaultTheme) => ({
  primary: css`
    .ant-collapse-item {
      .ant-collapse-header {
        background-color: ${theme.colors.neutralSilver5};
      }

      .ant-collapse-content > .ant-collapse-content-box {
        background-color: ${theme.colors.neutralSilver5};
      }
    }
  `,
  secondary: css`
    .ant-collapse-item {
      .ant-collapse-header {
        background-color: ${theme.colors.globalWhite100};
      }

      .ant-collapse-content > .ant-collapse-content-box {
        background-color: ${theme.colors.globalWhite100};
      }
    }
  `,
});

export const Wrapper = styled.div<WrapperProps>`
  ${({ theme, variant }) => css`
    .ant-collapse {
      .ant-collapse-item {
        .ant-collapse-header {
          display: flex;
          justify-content: center;
          align-items: center;
          flex-direction: row-reverse;

          border-radius: 0 0 8px 8px;

          padding: 10px;
          border: none;

          .ant-collapse-header-text {
            flex: initial;

            font-weight: 500;
            font-size: 1.6rem;
            line-height: 2.6rem;
            color: ${theme.colors.neutralSilver70};
          }

          .ant-collapse-arrow {
            margin-right: 0;
            margin-left: 8px;
            transform: rotate(90deg);
            transition: 0.2s all ease-in-out;
          }
        }

        &.ant-collapse-item-active {
          .ant-collapse-header {
            .ant-collapse-arrow {
              transform: rotate(-180deg);
            }
          }
        }

        .ant-collapse-content > .ant-collapse-content-box {
          border-radius: 0 0 8px 8px;
        }
      }

      ${wrapperModifiers(theme)[variant]};
    }
  `}
`;
